import Swiper from 'swiper';
import {Autoplay, Keyboard, Navigation, Pagination, Parallax} from 'swiper/modules';

export function initHeroBannerSlider(query = document.querySelectorAll('.js-heroBannerSlider')) {
    for (const  heroBannerSlider of query) {
        if (heroBannerSlider.querySelectorAll('.swiper-slide').length <=1) {
            heroBannerSlider.querySelector('.js-heroBannerSlider-controls ').remove();
           continue;
        }
        const autoplay=heroBannerSlider.dataset.autoplay;
        Swiper.use([Autoplay, Navigation, Pagination, Parallax, Keyboard]);
        new Swiper(heroBannerSlider, {
            parallax: true,
            keyboard: true,
            loop: true,
            a11y: {
                slideRole: null,
                slideLabelMessage: null
            },
            autoplay: autoplay,
            items: 1,
            speed: 300,
            pagination: {
                el: heroBannerSlider.querySelector('.swiper-pagination'),
                clickable: true
            },
            navigation: {
                nextEl: heroBannerSlider.querySelector('.swiper-button-next'),
                prevEl: heroBannerSlider.querySelector('.swiper-button-prev'),
            }
        });
    }
}
